import type { CartItem } from '../../../cart'

type Props = {
  items: CartItem[]
  removeLabel: string
  unitPriceLabel: (price: string) => string
  formatCurrency: (value: number) => string
  isItemBusy: (itemId: string) => boolean
  onIncrease: (item: CartItem) => void
  onDecrease: (item: CartItem) => void
  onRemove: (item: CartItem) => void
}

export const CartItemsSection = ({
  items,
  removeLabel,
  unitPriceLabel,
  formatCurrency,
  isItemBusy,
  onIncrease,
  onDecrease,
  onRemove,
}: Props) => (
  <section className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm sm:p-6">
    <ul className="space-y-3">
      {items.map((item) => {
        const itemBusy = isItemBusy(item.itemId)
        const imageUrl = item.productImageUrl || ''

        return (
          <li
            key={item.itemId}
            className="grid gap-3 rounded-xl border border-slate-200 bg-slate-50 px-3 py-3 sm:grid-cols-[84px_1fr]"
          >
            {imageUrl ? (
              <img
                src={imageUrl}
                alt={item.productName}
                className="h-20 w-20 rounded-lg border border-slate-200 bg-white object-cover"
                loading="lazy"
              />
            ) : (
              <div className="grid h-20 w-20 place-items-center rounded-lg border border-slate-200 bg-white text-[10px] font-semibold uppercase tracking-[0.12em] text-slate-500">
                N/A
              </div>
            )}
            <div className="space-y-2">
              <div className="flex flex-wrap items-start justify-between gap-3">
                <div className="space-y-1">
                  <p className="font-semibold text-slate-900">{item.productName}</p>
                  <p className="text-xs text-slate-600">{unitPriceLabel(formatCurrency(item.unitPriceSnapshot))}</p>
                </div>
                <div className="text-right text-sm font-semibold text-slate-900">{formatCurrency(item.lineTotal)}</div>
              </div>
              <div className="flex items-center gap-2">
                <button
                  type="button"
                  onClick={() => {
                    onDecrease(item)
                  }}
                  disabled={itemBusy}
                  className="grid h-9 w-9 place-items-center rounded-lg border border-slate-300 bg-white text-lg font-semibold text-slate-700 transition hover:border-emerald-300 hover:text-emerald-800 disabled:cursor-not-allowed disabled:opacity-60"
                >
                  -
                </button>
                <span className="min-w-10 text-center text-sm font-semibold text-slate-900">
                  {item.quantity}
                </span>
                <button
                  type="button"
                  onClick={() => {
                    onIncrease(item)
                  }}
                  disabled={itemBusy}
                  className="grid h-9 w-9 place-items-center rounded-lg border border-slate-300 bg-white text-lg font-semibold text-slate-700 transition hover:border-emerald-300 hover:text-emerald-800 disabled:cursor-not-allowed disabled:opacity-60"
                >
                  +
                </button>
                <button
                  type="button"
                  onClick={() => {
                    onRemove(item)
                  }}
                  disabled={itemBusy}
                  className="ml-auto rounded-lg border border-rose-200 bg-rose-50 px-3 py-1.5 text-xs font-semibold text-rose-700 transition hover:border-rose-300 disabled:cursor-not-allowed disabled:opacity-60"
                >
                  {removeLabel}
                </button>
              </div>
            </div>
          </li>
        )
      })}
    </ul>
  </section>
)
